import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Upload } from 'lucide-react';
import { Button } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

export interface FloatingLoadBarProps {
  /** Savatdagi yozuvlar soni. Nol bo'lsa panel chizilmaydi. */
  count: number;
  onLoad: () => void;
}

/**
 * «YUKLASH» — TELEFONDA SUZUVCHI.
 *
 * Telefonda hujjat toolbari yopishmaydi (u birinchi kartochkalarni
 * yopib qo'yardi), ya'ni ro'yxatning o'rtasida turgan skladchi «Yuklash»
 * ni ko'rmaydi va unga yetish uchun tepaga qaytishi kerak bo'lardi.
 * Shuning uchun savatda narsa bo'lganda tugma pastki tabbar USTIDA suzib
 * turadi. Bo'sh savatda u umuman yo'q: o'chiq tugma ekran pastini bekorga
 * egallardi.
 *
 * O'zi egallagan joy sahifa oxirida `FloatingLoadBarSpacer` bilan
 * qoldiriladi — oxirgi kartochka tugma ostida qolib ketmasin.
 */
export const FloatingLoadBar = ({ count, onLoad }: FloatingLoadBarProps) => {
  const reduceMotion = useReducedMotion() === true;
  return (
    <AnimatePresence>
      {count > 0 ? (
        <motion.div
          key="load"
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 24 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="fixed inset-x-3 bottom-[calc(var(--size-tabbar)+env(safe-area-inset-bottom)+0.75rem)] z-[var(--z-sticky-bar)] mx-auto max-w-xl"
        >
          <Button
            variant="accent"
            size="lg"
            onClick={onLoad}
            className="w-full shadow-[var(--shadow-2)] active:scale-[0.98] motion-reduce:active:scale-100"
          >
            <Upload size={18} aria-hidden />
            {t('supply.loadCount', { count })}
          </Button>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

/** Suzuvchi tugma balandligicha bo'sh joy — ro'yxat oxiri uning ostida qolmasin. */
export const FloatingLoadBarSpacer = () => <div aria-hidden className="h-14" />;
